import React from 'react';
import { Accordion, TextField, Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import { ChatDocumentationLink } from '@scale/shared/chat/documentation';
import ConfigSectionHeader from '../components/ConfigSectionHeader';

interface SpecializationsProps {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  useAccordion?: boolean;
}

const Specializations = ({ value, onSubmit, useAccordion = true }: SpecializationsProps) => {
  const WrappingComponent = useAccordion ? Accordion : ConfigSectionHeader;
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Specializations</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        {`Specify a specialization routing or worker skill routing for contributors. If you want certain contributors to work on
            specific “specialized” tasks, e.g. in a coding project, having python coders only work
            on python tasks, you can add a variable name using double brackets “{{}}” to the below fields
            to enable specialized task routing. See documentation `}
        <a
          className="text-primary-500"
          target="_blank"
          rel="noopener noreferrer"
          href={ChatDocumentationLink.SpecializedTaskRouting}
        >
          here
        </a>
        .
      </Typography.Paragraph2>

      <WrappingComponent header={'Specialization Options'}>
        <div>
          <Typography.Subtitle3>Add Specializations Routing to Tasks</Typography.Subtitle3>
          <div className="space-y-2 mt-2">
            <TextField
              id="specializations"
              value={value.specializations}
              onChange={e => onSubmit({ ...value, specializations: e.target.value })}
            />
          </div>
        </div>

        <div className="mt-2">
          <Typography.Subtitle3>Add Worker Skills Routing to Tasks</Typography.Subtitle3>
          <div className="space-y-3 mt-1">
            <TextField
              id="workerSkills"
              value={value.workerSkills}
              onChange={e => onSubmit({ ...value, workerSkills: e.target.value })}
            />
          </div>
        </div>
      </WrappingComponent>
    </div>
  );
};

export default Specializations;
